module.exports = __webpack_public_path__ + "img/Data Transformation.ace4de26.svg";